// extracted by mini-css-extract-plugin
export default {"bg":"PersonalLoan_bg__ZsltW","container":"PersonalLoan_container__4tRNB","left":"PersonalLoan_left__zGH7q","right":"PersonalLoan_right__HC8S7"};